import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Production from "@/pages/Production";
import Workers from "@/pages/Workers";
import WorkerDetail from "@/pages/WorkerDetail";
import Bon from "@/pages/Bon";
import Ledger from "@/pages/Ledger";
import Payroll from "@/pages/Payroll";
import Analytics from "@/pages/Analytics";
import Report from "@/pages/Report";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import Panggil from "@/pages/Panggil";
import Totalan from "@/pages/Totalan";
import Account from "@/pages/Account";
import AdminApprovals from "@/pages/AdminApprovals";
import InputOperator from "@/pages/InputOperator";
import OperasionalHome from "@/pages/op/OperasionalHome";
import Pengambilan from "@/pages/op/Pengambilan";
import Setoran from "@/pages/op/Setoran";
import Rijek from "@/pages/op/Rijek";
import OpHistory from "@/pages/op/OpHistory";
import Contoh from "@/pages/op/Contoh";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useLocation } from "react-router-dom";

function Protected({ children, module = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null)
    return <div className="h-screen flex items-center justify-center text-slate-500">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "PENCATAT" && !module)
    return <Navigate to="/operasional-jahitan" replace />;
  return <Layout><ErrorBoundary resetKey={loc.pathname}>{children}</ErrorBoundary></Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/production" element={<Protected><Production /></Protected>} />
          <Route path="/workers" element={<Protected><Workers /></Protected>} />
          <Route path="/workers/:workerId" element={<Protected><WorkerDetail /></Protected>} />
          <Route path="/bon" element={<Protected><Bon /></Protected>} />
          <Route path="/ledger" element={<Protected><Ledger /></Protected>} />
          <Route path="/payroll" element={<Protected><Payroll /></Protected>} />
          <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/report" element={<Protected><Report /></Protected>} />
          <Route path="/totalan" element={<Protected><Totalan /></Protected>} />
          <Route path="/panggil" element={<Protected><Panggil /></Protected>} />
          <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/akun" element={<Protected><Account /></Protected>} />
          <Route path="/persetujuan" element={<Protected><AdminApprovals /></Protected>} />
          <Route path="/input-operator" element={<Protected><InputOperator /></Protected>} />
          <Route path="/operasional-jahitan" element={<Protected module><OperasionalHome /></Protected>} />
          <Route path="/operasional-jahitan/pengambilan" element={<Protected module><Pengambilan /></Protected>} />
          <Route path="/operasional-jahitan/setoran" element={<Protected module><Setoran /></Protected>} />
          <Route path="/operasional-jahitan/rijek" element={<Protected module><Rijek /></Protected>} />
          <Route path="/operasional-jahitan/contoh" element={<Protected module><Contoh /></Protected>} />
          <Route path="/operasional-jahitan/riwayat" element={<Protected module><OpHistory /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
